import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import ErrorAlert from '../Alerts/ErrorAlert';
import LoadingAlert from '../Alerts/LoadingAlert';
import Swal from 'sweetalert2';
import './ModalWarehouses.css';


function ModalWarehouses({ show, setShow, warehouses, setWarehouseSelected }) {

    const [eventHandler, setEventHandler] = useState(0);

    // Function to save the selected warehouse in localStorage and update the state
    const saveWarehouse = (warehouse) => {
        localStorage.setItem('warehouse', JSON.stringify(warehouse));
        Swal.fire({
            icon: 'success',
            title: 'Bodega seleccionada',
            text: `Bodega ${warehouse.name} seleccionada correctamente.`,
            showConfirmButton: true,
            timer: 5000
        });
        setWarehouseSelected(warehouse);
        setEventHandler(1)
        setShow(false);
        updatePage()
    }


    // Function to update the page after selecting a warehouse
    const updatePage = () => {
        window.location.reload()
    }

    // Ícono según el tipo de bodega (cocina / bodega). Solo estético.
    const isKitchen = (w) => `${w?.type || w?.warehouse_type || w?.category || ''}`.toLowerCase().includes('cocina');


    useEffect(() => { setEventHandler(0) }, [eventHandler]);
    return (
        <>
            <Modal
                show={show}
                size="xl"
                centered
                onHide={() => setShow(false)}
                dialogClassName="sp-wh-dialog"
                contentClassName="sp-wh-content"
            >
                <Modal.Body className="sp-wh">

                    {/* Encabezado */}
                    <div className="sp-wh__head">
                        <i className="uil uil-database-alt"></i>
                        <h1 className="sp-wh__title">Bodegas</h1>
                    </div>

                    <p className="sp-wh__subtitle">Listado de Bodegas</p>

                    {/* Grid */}
                    <div className="sp-wh__panel">
                        <div className="sp-wh__grid">

                            {/* Sin bodega */}
                            <div className="sp-whcard sp-whcard--none" onClick={() => saveWarehouse({ name: "Selecciona una bodega", id: 0 })}>
                                <div className="sp-whcard__ic sp-whcard__ic--none">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="12" cy="12" r="9" /><line x1="5" y1="5" x2="19" y2="19" /></svg>
                                </div>
                                <h5 className="sp-whcard__name">Sin bodega</h5>
                                <span className="sp-whcard__meta">Sin asignar</span>
                                <span className="sp-whcard__status is-off"><span className="dot" /> Sin inventario</span>
                            </div>

                            {/* Bodegas */}
                            {warehouses.map((warehouse, index) => (
                                <div className="sp-whcard" onClick={() => saveWarehouse(warehouse)} key={warehouse.id ?? index}>
                                    <div className={`sp-whcard__ic ${isKitchen(warehouse) ? 'is-kitchen' : 'is-store'}`}>
                                        {isKitchen(warehouse) ? (
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M8 2v7a2 2 0 002 2v11M8 6h4M6 2v7a3 3 0 003 3M16 2c-1.5 1.5-2 4-2 7s.5 4 2 4v9" /></svg>
                                        ) : (
                                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M3 21V10l9-6 9 6v11" /><path d="M3 10h18M9 21v-6h6v6" /></svg>
                                        )}
                                    </div>
                                    <h5 className="sp-whcard__name" title={warehouse.name}>{warehouse.name}</h5>
                                    <span className="sp-whcard__meta">
                                        {isKitchen(warehouse) ? 'Cocina' : 'Bodega'}
                                        {(warehouse.products_count ?? warehouse.total_products ?? warehouse.products) != null
                                            ? ` · ${warehouse.products_count ?? warehouse.total_products ?? warehouse.products} productos`
                                            : ''}
                                    </span>
                                    <span className="sp-whcard__status is-on"><span className="dot" /> Disponible</span>
                                </div>
                            ))}

                        </div>

                        <div className="sp-wh__note">
                            <i className="uil uil-info-circle"></i> Por favor, seleccione una bodega
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="sp-wh__foot">
                        <button className="sp-wh__back" onClick={() => setShow(false)}>
                            <i className="uil uil-arrow-left"></i> Volver
                        </button>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalWarehouses